import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable, of, Subject, Subscription, throwError } from 'rxjs';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { APIListingResponseInterface } from '@app/core/_common/model';
import { ClientShippingAddressService } from '@app/core/client/services/client-shipping-address.service';
import { Client, ClientShippingAddress } from '@app/core/client/store/client.model';

import { ShippingAddressPopupFormComponent } from '../shipping-address-popup-form/shipping-address-popup-form.component';

@Component({
  selector: 'cnc-shipping-address-inline-table',
  templateUrl: './shipping-address-inline-table.component.html',
  styleUrls: ['./shipping-address-inline-table.component.scss'],
})
export class ShippingAddressInlineTableComponent implements OnInit, OnDestroy {
  @Input() businessAccount :Client;

  shippingAddresses$ :Observable<ClientShippingAddress[]>;
  private onDestroy$ = new Subject();

  shippingAddressSubscription :Subscription;
  defaultShippingAddressId :number;
  constructor(
    private modal :NgbModal,
    private shippingAddressService :ClientShippingAddressService,
    private cd :ChangeDetectorRef,
    private toastr :ToastrService,
  ) {}

  ngOnInit() :void {
    this.shippingAddresses$ = this.shippingAddressService.clientShippingAddress$;
    this.shippingAddressSubscription = this.shippingAddresses$.subscribe(
      (shippingAddresses :ClientShippingAddress[]) => {
        const defaultShippingAddress :ClientShippingAddress =
          shippingAddresses.find(
            (shippingAddress :ClientShippingAddress) => shippingAddress.default,
          );
        if (defaultShippingAddress) {
          this.defaultShippingAddressId = defaultShippingAddress.id;
        }
        this.cd.detectChanges();
      },
    );
    this.getShippingAddress();
  }

  ngOnDestroy() :void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
    this.shippingAddressSubscription.unsubscribe();
  }

  private getShippingAddress() {
    if (this.businessAccount && this.businessAccount.id) {
      this.shippingAddressService.get(this.businessAccount.id, {});
    }
  }

  delete(shippingAddress :ClientShippingAddress, idx :number) {
    Swal.fire({
      title: 'Confirm',
      text: 'Are you sure to delete this shipping address?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirm delete',
    }).then((result) => {
      if (result.value) {
        this.shippingAddressService
          .delete(this.businessAccount.id, shippingAddress.id)
          .pipe(
            catchError((response) => {
              this.toastr.error(
                response.error || 'Delete error. Try again later.',
                'Error',
              );

              return throwError(response.error);
            }),
            takeUntil(this.onDestroy$),
          )
          .subscribe(() => {
            this.toastr.success('Deleted successfully.', 'Success');
          });
      }
    });
  }

  openPopupForm(shippingAddress ?:ClientShippingAddress) {
    const modalRef = this.modal.open(ShippingAddressPopupFormComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.businessAccount = this.businessAccount;
    if (shippingAddress) {
      modalRef.componentInstance.shippingAddress = shippingAddress;
    }
  }

  setDefaultShipping() {
    this.shippingAddressService
      .setDefault(this.businessAccount.id, this.defaultShippingAddressId)
      .pipe(
        catchError((response) => {
          this.toastr.error(
            response.error || 'Update error. Try again later.',
            'Error',
          );

          return throwError(response.error);
        }),
        takeUntil(this.onDestroy$),
      )
      .subscribe(() => {
        this.toastr.success('Set successfully.', 'Success');
      });
  }
}
